import { Flex } from '@chakra-ui/react'
import styled from '@emotion/styled'

export const RentalSectionFooterWrapper = styled(Flex)`
  display: flex;
  flex-wrap: wrap;

  margin: 0 -10px;

  > * {
    margin: 0 10px;
    flex: 1;
  }
`
